import React, { useEffect, useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Users, Cpu, Activity, Bell, RefreshCw, LogOut, BookOpen } from 'lucide-react';
import { useAuth } from '../store/authStore';
import { apiGet } from '../api/client';
export function AdminShell() {
  const {
    user,
    token,
    logout
  } = useAuth();
  const navigate = useNavigate();
  const [activeAlertsCount, setActiveAlertsCount] = useState(0);
  useEffect(() => {
    if (!token) return;
    apiGet('/admin/alerts/all?status=active&limit=1', token).then(res => {
      setActiveAlertsCount(res.total || 0);
    }).catch(err => {
      console.error('Failed to fetch active alerts count:', err);
      setActiveAlertsCount(0);
    });
  }, [token]);
  const handleLogout = () => {
    logout();
    navigate('/login');
  };
  const navItems = [{
    icon: LayoutDashboard,
    label: 'Dashboard',
    path: '/dashboard'
  }, {
    icon: Users,
    label: 'Users',
    path: '/users'
  }, {
    icon: Cpu,
    label: 'Devices',
    path: '/devices'
  }, {
    icon: Activity,
    label: 'Sessions',
    path: '/sessions'
  }, {
    icon: Bell,
    label: 'Alerts',
    path: '/alerts',
    badge: activeAlertsCount
  }, {
    icon: BookOpen,
    label: 'Content',
    path: '/content'
  }, {
    icon: RefreshCw,
    label: 'Sync Logs',
    path: '/sync-logs'
  }];
  return <div className="min-h-screen bg-background flex" data-id="element-31">
      {/* Sidebar */}
      <aside className="w-[220px] fixed inset-y-0 left-0 bg-background border-r border-border flex flex-col" data-id="element-32">
        <div className="p-6" data-id="element-33">
          <div className="flex items-center gap-3 mb-6" data-id="element-34">
            <div className="w-8 h-8 rounded-full bg-accent flex items-center justify-center" data-id="element-35">
              <div className="w-3 h-3 bg-white rounded-full" data-id="element-36" />
            </div>
            <span className="text-[16px] font-semibold text-white" data-id="element-37">
              Aurora Care Admin
            </span>
          </div>
          <div className="h-[1px] bg-border w-full mb-6" data-id="element-38" />

          <nav className="flex flex-col gap-[2px]" data-id="element-39">
            {navItems.map(item => <NavLink key={item.path} to={item.path} className={({
            isActive
          }) => `
                  w-full h-[36px] rounded-btn pl-3 pr-3 flex items-center gap-[10px] transition-colors duration-150
                  ${isActive ? 'bg-[rgba(107,33,232,0.15)] text-accent border border-[rgba(107,33,232,0.3)]' : 'bg-transparent text-text-secondary hover:bg-surface border border-transparent'}
                `} data-id="element-40">
                <item.icon className="w-4 h-4" data-id="element-41" />
                <span className="text-[14px] font-medium flex-1" data-id="element-42">
                  {item.label}
                </span>
                {item.badge && item.badge > 0 ? <span className="bg-danger text-white text-[10px] font-bold px-1.5 py-0.5 rounded-badge min-w-[20px] text-center" data-id="element-43">
                    {item.badge}
                  </span> : null}
              </NavLink>)}
          </nav>
        </div>

        <div className="mt-auto p-4 border-t border-border" data-id="element-44">
          <div className="flex items-center gap-3" data-id="element-45">
            <div className="w-7 h-7 rounded-full bg-accent flex items-center justify-center text-white text-xs font-bold" data-id="element-46">
              {user?.email?.charAt(0).toUpperCase() || 'A'}
            </div>
            <span className="text-[13px] text-text-secondary truncate flex-1" data-id="element-47">
              {user?.email || 'admin@auroracare.com'}
            </span>
            <button onClick={handleLogout} className="text-text-tertiary hover:text-white transition-colors" title="Log out" data-id="element-48">
              <LogOut className="w-4 h-4" data-id="element-49" />
            </button>
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 ml-[220px] bg-background min-h-screen" data-id="element-50">
        <div className="p-8" data-id="element-51">
          <Outlet data-id="element-52" />
        </div>
      </main>
    </div>;
}